import { LiveToolbar } from "@faire/prototype-playground/platform/components/toolbar/LiveToolbar";
import type { PrototypeMetadata } from "@faire/prototype-playground/workspace/types";
import { useEffect } from "react";

import { AdsManagerOverviewPage } from "./AdsManagerOverviewPage";
import { BrandSidebar } from "./BrandSidebar";

export const prototypeMeta: PrototypeMetadata = {
  name: "Ads Manager Profit Calculator",
  owner: "Yanwu Gu",
  email: "yanwu.gu@faire.com",
  status: "in-progress",
  createdAt: "2026-06-09",
  lastUpdated: "2026-06-09",
  surfaceArea: "Brand",
  category: "experimental",
  creationTool: "claude-code",
  thumbnail: "/images/thumbnails/yg-ads-manager-profit-calculator.png",
  description:
    "Profit calculator prototype on the Promoted Listings overview dashboard",
};

export default function AdsManagerProfitCalculatorPage() {
  useEffect(() => {
    document.title = prototypeMeta.name;
  }, []);

  return (
    <>
      <LiveToolbar />
      <div className="bg-fs-surface-secondary flex min-h-screen">
        <BrandSidebar />
        <AdsManagerOverviewPage />
      </div>
    </>
  );
}
